<template>
  <div class="dashboard">
    <NavbarMain/>
    <router-view></router-view>
  </div>
</template>
<script>
  import NavbarMain from '../components/NavbarMain';
  import {mapGetters, mapActions} from 'vuex';

  export default {
    name: 'Dashboard',
    methods: {
      ...mapActions(['fetchMe'])
    },
    computed: {
      ...mapGetters(['me']),
    },
    components: {
      NavbarMain
    },
    created() {
      this.fetchMe();
    },
  }
</script>
<style lang="scss">

  .dashboard {
    /*padding-top: 62px;*/
  }

</style>
